export default "__VITE_ASSET__d4x2RB2Z__"